module.exports = __webpack_public_path__ + "static/img/banner2.a5d97c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/banner2.png
// module id = svoo
// module chunks = 1